export default __webpack_public_path__ + "static/media/bid-hammer.e560a6bb.png";